import { Button, Textarea } from '@packages/ui';
import { useFieldArray, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import zod from 'zod';
import { Step } from './Step';
import { useTranslation } from 'react-i18next';

const formSchema = zod.object({
  memories: zod.array(zod.object({ content: zod.string().min(2).max(1000) })),
});

type FormData = zod.infer<typeof formSchema>;

type Props = {
  defaultData?: FormData;
  onSubmit: (data: FormData) => void;
  isActive: boolean;
  isDone: boolean;
  onActivate: () => void;
};
export const StepMemories = ({ onSubmit, defaultData, isActive, isDone, onActivate }: Props) => {
  const form = useForm<FormData>({
    defaultValues: defaultData,
    resolver: zodResolver(formSchema),
  });

  const { fields, append, remove } = useFieldArray({
    name: 'memories',
    control: form.control,
  });

  const { t } = useTranslation();

  const placeholders = [
    t('wedding.memoryPlaceholder1'),
    t('wedding.memoryPlaceholder2'),
    t('wedding.memoryPlaceholder3'),
    t('wedding.memoryPlaceholder4'),
    t('wedding.memoryPlaceholder5'),
  ];

  return (
    <Step
      question={t('wedding.memoriesQuestion')}
      form={form}
      onNext={onSubmit}
      isActive={isActive}
      isDone={isDone}
      onActivate={onActivate}>
      <ul className="space-y-2">
        {fields.map((field, index) => (
          <li key={field.id}>
            <h1 className="mb-1">
              {t('memory')} {index + 1}
            </h1>
            <Textarea
              placeholder={placeholders[index]}
              disabled={!isActive}
              className="w-full"
              {...form.register(`memories.${index}.content`)}
            />
          </li>
        ))}
      </ul>
      <div className="flex gap-2 mt-2">
        {fields.length > 1 ? (
          <Button size="md" variant={'outline'} onClick={() => remove(fields.length - 1)}>
            {t('removeMemory')}
          </Button>
        ) : null}
        <Button
          size="md"
          disabled={fields.length === placeholders.length}
          onClick={() => append({ content: '' })}>
          {t('addAnotherMemory')}
        </Button>
      </div>
    </Step>
  );
};
